import React from "react";

export const RawBuildFailPanel = ({ diag, rules, onRemoveRule, onDismiss }) => {
  if (!diag || !diag.messages?.length) return null;
  const culprits = new Set(diag.culprits || []);
  return (
    <div data-testid="raw-build-fail-panel" className="mt-3 border border-[#FF3B30]/60 bg-[#FF3B30]/10">
      <div className="flex items-center justify-between px-4 py-2.5 border-b border-[#FF3B30]/30">
        <div className="mono text-[11px] font-black uppercase tracking-widest text-[#FF3B30]">
          Built 0 lineups · here's why
        </div>
        <button type="button" onClick={onDismiss} data-testid="raw-build-fail-dismiss"
          className="mono text-[10px] uppercase tracking-widest text-zinc-400 hover:text-white">
          Dismiss
        </button>
      </div>
      <ul className="px-4 py-3 space-y-2">
        {diag.messages.map((m, i) => (
          <li key={i} data-testid={`raw-build-fail-msg-${i}`} className="text-[11px] text-zinc-200 leading-relaxed flex items-start gap-2">
            <span className="text-[#FF3B30] mt-[1px]">▸</span>
            <span className="flex-1">{m}</span>
          </li>
        ))}
      </ul>
      {culprits.size > 0 && rules?.length > 0 && (
        <div className="px-4 pb-3 flex flex-wrap gap-2">
          {[...culprits].filter((k) => rules[k]).map((k) => (
            <button key={k} type="button" onClick={() => onRemoveRule(k)} data-testid={`raw-build-fail-remove-rule-${k}`}
              className="mono text-[10px] uppercase tracking-widest border border-[#39FF14] text-[#39FF14] hover:bg-[#39FF14] hover:text-black px-2.5 py-1 font-bold transition-colors">
              Remove rule {k + 1}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
